import { makeAutoObservable } from 'mobx';
import type { RightSidebarStore } from '../RightSidebar/store';
import { CHAT_MIN_WIDTH } from '../SecodaAppShell/constants';

export type PageSideCanvasMode<
	T extends Record<string, unknown> = Record<string, unknown>,
> = { mode: 'hide' } | { mode: 'show'; objectToShow: T };

export class RightSideCanvasStore<
	T extends Record<string, unknown> = Record<string, unknown>,
> {
	pageSideCanvasWidth: number = 400;

	pageSideCanvasMode: PageSideCanvasMode<T> = { mode: 'hide' };

	rightSidebarStore: RightSidebarStore;

	onModeChangeCallback?: (mode: PageSideCanvasMode<T>) => void;

	setPageSideCanvasWidth = (width: number) => {
		const availableWidth = window.innerWidth;
		const maxWidth = availableWidth - CHAT_MIN_WIDTH;

		this.pageSideCanvasWidth = Math.min(
			Math.max(width, CHAT_MIN_WIDTH),
			maxWidth
		);
	};

	setPageSideCanvasMode = (mode: PageSideCanvasMode<T>) => {
		this.pageSideCanvasMode = mode;
		if (mode.mode === 'show') {
			this.rightSidebarStore.setCollapsed(true);

			const availableWidth = window.innerWidth;
			this.setPageSideCanvasWidth(availableWidth - CHAT_MIN_WIDTH);
		}

		this.onModeChangeCallback?.(mode);
	};

	constructor({
		rightSidebarStore,
		onModeChangeCallback,
	}: {
		rightSidebarStore: RightSidebarStore;
		onModeChangeCallback?: (mode: PageSideCanvasMode<T>) => void;
	}) {
		this.rightSidebarStore = rightSidebarStore;
		this.pageSideCanvasMode = { mode: 'hide' };
		this.onModeChangeCallback = onModeChangeCallback;
		// Set default width to maximum available width for first-time users
		const availableWidth = window.innerWidth;
		this.pageSideCanvasWidth = availableWidth - CHAT_MIN_WIDTH;
		makeAutoObservable(this);
	}
}
